export default {
    cn: {
        monitorAccounts: {
            accHead: [
                { key: 'COMMENT_1', value: '描述', writable: true },
                { key: 'LOGIN', value: '客户账号' },
                { key: 'NAME', value: '客户姓名' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'IB_ID', value: '代理账号' },
                { key: 'ACC_NAME', value: '办事处' },
                { key: 'ZIPCODE', value: '邮编' },
                { key: 'DEPOSIT_TODAY', value: '今日入金' },
                { key: 'WITHDRAWAL_TODAY', value: '今日出金' },
                { key: 'CLOSED_PL', value: '今日平仓盈亏' },
                { key: 'TOTAL_FLOATING_PL', value: '至今未平仓盈亏' },
                { key: 'TOTAL_CLOSE_PL', value: '至今平仓盈亏' },
                { key: 'TOTAL_PL', value: '至今总盈亏' },
            ],
            tableHead: [
                { key: 'CREATE_DATE', value: '加入名单日期' },
                { key: 'COMMENT_2', value: '描述2', writable: true },
                { key: 'USED_IP', value: '曾经使用的IP', table: true },
                { key: 'COMMENT_3', value: '描述3', writable: true },
                { key: 'LOG_TIME_UNTIL_IP', value: 'IP日志时间' },
                { key: 'COMMENT_4', value: '描述4', writable: true },
                { key: 'LOG_TIME_UNTIL_IP_RELATED', value: '关联IP日志时间' },
                { key: 'COMMENT_5', value: '描述5', writable: true },
            ],
            ipTableHead: [
                { key: 'IP', value: 'IP' },
                { key: 'RELATED_LOGINS', value: '关联的账号' },
            ],
            tradesHead: [
                { key: 'TICKET', value: '交易单号' },
                { key: 'LOGIN', value: '账号' },
                { key: 'TIME', value: '时间' },
                { key: 'PRICE', value: '价格' },
                { key: 'TYPE', value: '开仓/平仓' },
                { key: 'CMD', value: '买/卖' },
                { key: 'VOLUME', value: '手数' },
                { key: 'SYMBOL', value: '产品' },
            ],
            rules: {
                login: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                    { type: 'number', message: '账号必须为数字值' },
                ],
                comment: [{ required: true, message: '请填写描述', trigger: 'blur' }],
            },
            close: '平仓',
            open: '开仓',
            commentOpt: { 1: '短线交易', 2: '打平台', 3: '交易行为可疑', 4: '盈利能力高', 5: '团体交易', 6: '其他' },
            excelName: 'IP关联账号',
            addBtnTxt: '新增客户到监察名单',
            badgeBtnTxt: '监察客户近期交易单明细',
            showIPBtnTxt: '点击查看',
            lastTableColumnTxt: '操作',
            addDialogTitle: '请填写客户账号信息',
            formLoginLabel: '客户账号',
            formCommentLabel: '描述',
            formSelectDefaultTxt: '请选择',
            formCancelTxt: '取 消',
            formConfirmTxt: '确 定',
            ipTableDialogTitle: '曾经使用的IP及关联账号',
            ipTableKeywordTxt: '输入关键字搜索',
            addSuccess: '新增监察客户账号成功',
            addFailed: '新增监察客户账号失败',
            notifyTxt: '提示',
            updateMsg1Txt: '是否更新账号',
            updateMsg2Txt: '的描述',
            updateSuccess: '更新成功',
            updateFailed: '更新失败或记录与更新前一致',
            deleteMsgTxt: '是否从监察名单中移除账号',
            delSuccess: '移除成功',
            delFailed: '移除失败',
        }
    },
    hk: {
        monitorAccounts: {
            accHead: [
                { key: 'COMMENT_1', value: '描述', writable: true },
                { key: 'LOGIN', value: '客戶賬號' },
                { key: 'NAME', value: '客戶姓名' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'IB_ID', value: '代理賬號' },
                { key: 'ACC_NAME', value: '辦事處' },
                { key: 'ZIPCODE', value: '郵編' },
                { key: 'DEPOSIT_TODAY', value: '今日入金' },
                { key: 'WITHDRAWAL_TODAY', value: '今日出金' },
                { key: 'CLOSED_PL', value: '今日平倉盈虧' },
                { key: 'TOTAL_FLOATING_PL', value: '至今未平倉盈虧' },
                { key: 'TOTAL_CLOSE_PL', value: '至今平倉盈虧' },
                { key: 'TOTAL_PL', value: '至今縂盈虧' },
            ],
            tableHead: [
                { key: 'CREATE_DATE', value: '加入名單日期' },
                { key: 'COMMENT_2', value: '描述2', writable: true },
                { key: 'USED_IP', value: '曾經使用的IP', table: true },
                { key: 'COMMENT_3', value: '描述3', writable: true },
                { key: 'LOG_TIME_UNTIL_IP', value: 'IP日志時間' },
                { key: 'COMMENT_4', value: '描述4', writable: true },
                { key: 'LOG_TIME_UNTIL_IP_RELATED', value: '關聯IP日志時間' },
                { key: 'COMMENT_5', value: '描述5', writable: true },
            ],
            ipTableHead: [
                { key: 'IP', value: 'IP' },
                { key: 'RELATED_LOGINS', value: '關聯的賬號' },
            ],
            tradesHead: [
                { key: 'TICKET', value: '交易單號' },
                { key: 'LOGIN', value: '賬號' },
                { key: 'TIME', value: '時間' },
                { key: 'PRICE', value: '價格' },
                { key: 'TYPE', value: '開倉/平倉' },
                { key: 'CMD', value: '買/賣' },
                { key: 'VOLUME', value: '手數' },
                { key: 'SYMBOL', value: '產品' },
            ],
            rules: {
                login: [
                    { required: true, message: '請輸入賬號', trigger: 'blur' },
                    { type: 'number', message: '賬號必須為數字' },
                ],
                comment: [{ required: true, message: '請填寫描述', trigger: 'blur' }],
            },
            close: '平倉',
            open: '開倉',
            commentOpt: { 1: '短綫交易', 2: '打平臺', 3: '交易行爲可疑', 4: '盈利能力高', 5: '團體交易', 6: '其他' },
            excelName: 'IP關聯賬號',
            addBtnTxt: '新增客戶到監察名單',
            badgeBtnTxt: '監察客戶近期交易單明細',
            showIPBtnTxt: '點擊查看',
            lastTableColumnTxt: '操作',
            addDialogTitle: '請填寫客戶賬號信息',
            formLoginLabel: '客戶賬號',
            formCommentLabel: '描述',
            formSelectDefaultTxt: '請選擇',
            formCancelTxt: '取 消',
            formConfirmTxt: '確 定',
            ipTableDialogTitle: '曾經使用的IP及關聯賬號',
            ipTableKeywordTxt: '輸入關鍵字搜索',
            addSuccess: '新增監察客戶賬號成功',
            addFailed: '新增監察客戶賬號失敗',
            notifyTxt: '提示',
            updateMsg1Txt: '是否更新賬號',
            updateMsg2Txt: '的描述',
            updateSuccess: '更新成功',
            updateFailed: '更新失敗或記錄與更新前一致',
            deleteMsgTxt: '是否從監察名單中移除賬號',
            delSuccess: '移除成功',
            delFailed: '移除失敗',
        }
    },
    en: {
        monitorAccounts: {
            accHead: [
                { key: 'COMMENT_1', value: 'Comment', writable: true },
                { key: 'LOGIN', value: 'Login' },
                { key: 'NAME', value: 'Name' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'IB_ID', value: 'IB Account' },
                { key: 'ACC_NAME', value: 'Office Name' },
                { key: 'ZIPCODE', value: 'Zipcode' },
                { key: 'DEPOSIT_TODAY', value: 'Today\'s Deposit' },
                { key: 'WITHDRAWAL_TODAY', value: 'Today\'s Withdrawal' },
                { key: 'CLOSED_PL', value: 'Today\'s Closed PL' },
                { key: 'TOTAL_FLOATING_PL', value: 'Total Floating PL' },
                { key: 'TOTAL_CLOSE_PL', value: 'Total Closed PL' },
                { key: 'TOTAL_PL', value: 'Total PL' },
            ],
            tableHead: [
                { key: 'CREATE_DATE', value: 'Create Date' },
                { key: 'COMMENT_2', value: 'Comment 2', writable: true },
                { key: 'USED_IP', value: 'Used IP', table: true },
                { key: 'COMMENT_3', value: 'Comment 3', writable: true },
                { key: 'LOG_TIME_UNTIL_IP', value: 'Log Time Until IP' },
                { key: 'COMMENT_4', value: 'Comment 4', writable: true },
                { key: 'LOG_TIME_UNTIL_IP_RELATED', value: 'Log Time Until IP Related' },
                { key: 'COMMENT_5', value: 'Comment 5', writable: true },
            ],
            ipTableHead: [
                { key: 'IP', value: 'IP' },
                { key: 'RELATED_LOGINS', value: 'Related Logins' },
            ],
            tradesHead: [
                { key: 'TICKET', value: 'Ticket' },
                { key: 'LOGIN', value: 'Login' },
                { key: 'TIME', value: 'Time' },
                { key: 'PRICE', value: 'Price' },
                { key: 'TYPE', value: 'Open/Close' },
                { key: 'CMD', value: 'Buy/Sell' },
                { key: 'VOLUME', value: 'Volume' },
                { key: 'SYMBOL', value: 'Symbol' },
            ],
            rules: {
                login: [
                    { required: true, message: 'Please input login', trigger: 'blur' },
                    { type: 'number', message: 'The login must be number' },
                ],
                comment: [{ required: true, message: 'Please input comment', trigger: 'blur' }],
            },
            close: 'Close',
            open: 'Open',
            commentOpt: { 1: '短綫交易', 2: '打平臺', 3: '交易行爲可疑', 4: '盈利能力高', 5: '團體交易', 6: '其他' },
            excelName: 'IP related login',
            addBtnTxt: 'Add account to monitor list',
            badgeBtnTxt: 'Details of recent orders of monitored accounts',
            showIPBtnTxt: 'Click to view',
            lastTableColumnTxt: 'Handle',
            addDialogTitle: 'Please fill in the login information',
            formLoginLabel: 'Login',
            formCommentLabel: 'Comment',
            formSelectDefaultTxt: 'Please select',
            formCancelTxt: 'Cancel',
            formConfirmTxt: 'Confirm',
            ipTableDialogTitle: 'Used IP and related accounts',
            ipTableKeywordTxt: 'Enter a keyword search',
            addSuccess: 'The monitor account was successfully added',
            addFailed: 'Failed to add monitor account',
            notifyTxt: 'Tips',
            updateMsg1Txt: 'Are you sure need to update the account',
            updateMsg2Txt: '\'s comment?',
            updateSuccess: 'Update successfully',
            updateFailed: 'Update failed or the record is same as before',
            deleteMsgTxt: 'Are you sure need to delete the account from monitor list?',
            delSuccess: 'Delete successfully',
            delFailed: 'Delete failed',
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/report/monitorAccountsReport.js